export default __webpack_public_path__ + "static/media/central.3c639f61.png";